import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  templateUrl: 'empty-wrapper.component.html',
})
export class EmptyWrapperComponent extends FieldWrapper {
}
